export default "__VITE_ASSET__CYThV5vg__"